import { createRouter, createMemoryHistory } from 'vue-router'

import Welcome from "../components/Welcome.vue";
import SidebarLeftSettings from "../components/Sidebar/SidebarLeftSettings.vue";
import SidebarRightExport from "../components/Sidebar/SidebarRightExport.vue";
import Topbar from "../components/Topbar/Topbar.vue";
import JobCanvas from "../components/Content/JobCanvas.vue";
import MobileNavbar from "../components/Mobile/MobileNavbar.vue";
import Tools from "../components/Content/Tools.vue";
import OutputCompareImages from "../components/Content/Output/OutputCompareImages.vue";
import OutputHash from "../components/Content/Output/OutputHash.vue";
import OutputImage from "../components/Content/Output/OutputImage.vue";
import OutputMetadata from "../components/Content/Output/OutputMetadata.vue";
import OutputPdf from "../components/Content/Output/OutputPdf.vue";
import OutputTextToImage from "../components/Content/Output/OutputTextToImage.vue";
import OutputValidatePdfA from "../components/Content/Output/OutputValidatePdfA.vue";
import MetaInfo from "../components/Content/Output/MetaInfo.vue";
import FileList from "../components/Content/FileList.vue";
import FileListNav from "../components/SecondaryNavbar/FileListNav.vue";
import JobNotFound from "../components/Content/JobNotFound.vue";
import FileListMobile from "../components/Content/FileListMobile.vue";
import MobileFilesNavbar from "../components/Mobile/MobileFilesNavbar.vue";
import MobileBackBtnSecondaryNav from "../components/Mobile/Elements/MobileBackBtnSecondaryNav.vue";
import MobileDownloadBtnSecondaryNav from "../components/Mobile/Elements/MobileDownloadBtnSecondaryNav.vue";
import ToolsNav from "../components/SecondaryNavbar/ToolsNav.vue";
import ToolsMobile from "../components/Content/ToolsMobile.vue";
import MobileToolsNavbar from "../components/Mobile/MobileToolsNavbar.vue";
import OutputCompareVideo from "../components/Content/Output/OutputCompareVideo.vue";
import OutputTxt from "../components/Content/Output/OutputTxt.vue";
import FeedbackContent from "../components/Content/FeedbackContent.vue";
import FileNav from "../components/SecondaryNavbar/FileNav.vue";
import TxtFileNav from '../components/SecondaryNavbar/TxtFileNav.vue';
import MobileTxtBackBtnSecondaryNav from '../components/Mobile/Elements/MobileTxtBackBtnSecondaryNav.vue';


const routes = [
    {
        path: '/not-found',
        name: 'NotFound',
        components: {
            default: JobNotFound,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: SidebarLeftSettings,
            MobileNavbar: MobileNavbar,
        },
    },
    {
        path: '/:uuid/welcome',
        name: 'Welcome',
        components: {
            default: FileList,
            Topbar: Topbar,
            SecondaryNav: FileListNav,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: SidebarRightExport,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileDownloadBtnSecondaryNav,
        },
    },
    {
        path: '/:uuid/feedback',
        name: 'Feedback',
        components: {
            default: FeedbackContent,
            Topbar: Topbar,
            SecondaryNav: FileListNav,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: FeedbackContent,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav,
        },
    },
    {
        path: '/:uuid/not-found',
        name: 'JobIsNotFound',
        components: {
            default: JobNotFound,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: SidebarLeftSettings,
            MobileNavbar: MobileNavbar,
        },
    },
    {
        path: '/:uuid/tools',
        name: 'Tools',
        components: {
            default: Tools,
            Topbar: Topbar,
            SecondaryNav: ToolsNav,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: ToolsMobile,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileToolsNavbar,
        },
    },
    {
        path: '/:uuid/files',
        name: 'FileList',
        components: {
            default: FileList,
            Topbar: Topbar,
            SecondaryNav: FileListNav,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: FileListMobile,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileFilesNavbar,
        },
    },
    {
        path: '/:uuid/:outputid/metainfo',
        name: 'MetaInfo',
        components: {
            default: MetaInfo,
            Topbar: Topbar,
            SecondaryNav: FileNav,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: MetaInfo,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav,
        },
    },
    {
        path: '/:uuid/:outputid/compare-image',
        name: 'OutputCompareImages',
        components: {
            default: OutputCompareImages,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: OutputCompareImages,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav,
        },
    },
    {
        path: '/:uuid/:outputid/hash',
        name: 'OutputHash',
        components: {
            default: OutputHash,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: OutputHash,
            MobileNavbar: MobileNavbar,
        },
    },
    {
        path: '/:uuid/:outputid/image',
        name: 'OutputImage',
        components: {
            default: OutputImage,
            Topbar: Topbar,
            SecondaryNav: FileNav,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: OutputImage,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav,
        },
    },
    {
        path: '/:uuid/:outputid/txt',
        name: 'OutputTxt',
        components: {
            default: OutputTxt,
            Topbar: Topbar,
            SecondaryNav: TxtFileNav,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: OutputTxt,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileTxtBackBtnSecondaryNav,
        },
    },
    {
        path: '/:uuid/:outputid/metadata',
        name: 'OutputMetadata',
        components: {
            default: OutputMetadata,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: OutputMetadata,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav,
        },
    },
    {
        path: '/:uuid/:outputid/compare-video',
        name: 'OutputCompareVideo',
        components: {
            default: OutputCompareVideo,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: OutputCompareVideo,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav,
        },
    },
    {
        path: '/:uuid/:outputid/pdf',
        name: 'OutputPdf',
        components: {
            default: OutputPdf,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: SidebarLeftSettings,
            MobileNavbar: MobileNavbar,
        },
    },
    {
        path: '/:uuid/:outputid/text-to-image',
        name: 'OutputTextToImage',
        components: {
            default: OutputTextToImage,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: SidebarLeftSettings,
            MobileNavbar: MobileNavbar,
        },
    },
    {
        path: '/:uuid/:outputid/validate-pdfa',
        name: 'OutputValidatePdfA',
        components: {
            default: OutputValidatePdfA,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: OutputValidatePdfA,
            MobileNavbar: MobileNavbar,
            MobileSecondaryNavbar: MobileBackBtnSecondaryNav,
        },
    },
    {
        path: '/',
        name: 'WelcomeFirst',
        components: {
            default: Welcome,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: SidebarLeftSettings,
            MobileNavbar: MobileNavbar,
        },
    },
    {
        path: '/:uuid/canvas',
        name: 'JobCanvas',
        components: {
            default: JobCanvas,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: FileList,
            MobileNavbar: MobileNavbar,
        },
    },
    {
        path: '/:uuid',
        name: 'JobCanvasIndex',
        components: {
            default: JobCanvas,
            Topbar: Topbar,
            SidebarLeft: SidebarLeftSettings,
            SidebarRight: SidebarRightExport,
            MobileDefault: JobCanvas,
            MobileNavbar: MobileNavbar,
        },
    },

];

const router = createRouter({
    history: createMemoryHistory(),
    routes,
});

export default router;
